
<!-- 
  Article username section
-->

<template>
  <div>
    <h1>Welcome to Ralph PR John Smith</h1>
    <hr />
  </div>
</template>

<style>

</style>

<script>
// import Vue from 'vue'

export default {
  props: ['project'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
  },
  created () {
  },
  computed: {
    // a computed getter
  }
}
</script>



// WEBPACK FOOTER //
// ArticleUsername.vue?c21278e0